import { defineComponent as _defineComponent } from 'vue'
import Password from "primevue/password";
import {Field, Form} from "vee-validate";
import {object} from "yup";
import * as Yup from "yup";
import {ref} from "vue";
import {useUserServiceStore} from "@/store/userService.store";
import {useRoute, useRouter} from "vue-router";
import {useToast} from "vue-toastification";



export default /*#__PURE__*/_defineComponent({
  __name: 'SignInView',
  setup(__props, { expose: __expose }) {
  __expose();


const schema = object().shape({
  email:  Yup.string()
    .required( "This field is required"),
  password:  Yup.string()
    .required( "This field is required")
});

const email = ref<string>();
const password = ref<string>();

function login(){

  if(email.value && password.value) {
    useUserServiceStore().authEmailAccount({login: email.value, password: password.value}, onSuccessAuth);
  }
}

const router = useRouter();
const toast = useToast();
const onSuccessAuth = () => {
  toast.success('Successfully logged in');
  router.push({name: 'publicSaleInfo'});
};


const __returned__ = { schema, email, password, login, router, toast, onSuccessAuth, get Password() { return Password }, get Field() { return Field }, get Form() { return Form }, get useRoute() { return useRoute } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})